import { createSelector } from 'reselect';
import totalCreditsSelector from './totalCredits';

export default createSelector(totalCreditsSelector, (credits) => credits > 0);
